import {
  ZONES_LOADING,
  ZONES_ERROR,
  ZONES_LIST
} from "actions/scooter/zones/constants";

const initialState = {
  loading: false,
  errors: [],

  list: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ZONES_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case ZONES_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case ZONES_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload.content,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scooter/scooterZonesReducer.js